var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('counsel-card-row', {
    attrs: {
      "label": "기간"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "lg": "3"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "시작일"
    },
    model: {
      value: _vm.value.startsAt,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "startsAt", $$v);
      },
      expression: "value.startsAt"
    }
  }, 'v-text-field', _vm.inputProps, false))], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "lg": "3"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "종료일"
    },
    model: {
      value: _vm.value.endsAt,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "endsAt", $$v);
      },
      expression: "value.endsAt"
    }
  }, 'v-text-field', _vm.inputProps, false))], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }